import React, { useMemo } from 'react';
import styled from 'styled-components';

import { Button, CardActions, LinearProgress, Paper } from '@material-ui/core';

import CardContent from '../../../common/card/CardContent';
import { formatImgURLs } from '../../../common/inline/InlineHtml.hooks';
import DocumentViewer from '../../documents/components/DocumentViewer';
import { TrainingUserFileUpload } from '../components/TrainingUserFileUpload';
import {
  TrainingSection,
  TrainingSectionAttachmentProgress,
  TrainingUserAttachment
} from '../Training.interface';
import { Attachment } from '../../../common/attachment/Attachment.interface';

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: 30px 0 0 0;
  /* max-width: 1024px; */
  width: 90%;
  overflow: hidden;
  flex: 1;
  border-radius: 4px 4px 0 0;
  .lesson-content {
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    /* border-radius: 4px 4px 0 0; */
    .lesson-content-scroll {
      display: flex;
      flex-direction: column;
      overflow: auto;
      flex: 1;
      padding: 60px 60px 0 60px;

      .document-viewer {
        min-height: 100%;
      }

      ${props => props.theme.breakpoints.down('sm')} {
        padding: 20px 10px 20px 10px;
      }
    }
    .lesson-actions {
      padding: 12px 20px;
      border-top: 1px solid #eee;
      display: flex;
      .flex {
        flex: 1;
      }
    }
    .iframe-document {
      flex: 1;

      &.csv-viewer {
        /* remove min height and let flex fill up the remaining height */
        min-height: unset;
      }
    }
    .file-upload-container {
      margin-top: 18px;
    }

    form {
      display: flex;
      flex-direction: column;
    }
    .survey-description {
      margin-bottom: 30px;
    }
    h3 {
      font-size: 32px;
    }
    h5 {
      font-size: 18px;
    }
  }
`;

const TrainingLessonCard: React.FC<{
  isLoading: boolean;
  attachments: TrainingUserAttachment[];
  attachmentProgress?: TrainingSectionAttachmentProgress;
  section: TrainingSection;
  onPrevious?: () => void;
  onNext?: () => void;
  onChangeAttachments: (values: Attachment[]) => void;
  isViewOnly?: boolean;
}> = ({
  isLoading,
  attachments,
  attachmentProgress,
  section,
  onPrevious,
  onNext,
  onChangeAttachments,
  isViewOnly
}) => {
  const disabled = isLoading || isViewOnly;
  const isDoc: boolean = !section?.url?.includes('.pdf');
  const fileUpload = section?.fileUpload;
  const body: string = useMemo(() => {
    const body: string = section?.body || '';
    return body && formatImgURLs(body);
  }, [section]);

  return (
    <StyledPaper className='training-lesson-card' elevation={3}>
      {isLoading && <LinearProgress />}
      <div className='lesson-content'>
        <CardContent className='lesson-content-scroll'>
          <div
            className='html-content'
            dangerouslySetInnerHTML={{ __html: body }}
          />
          {section?.url && (
            <DocumentViewer
              storageKey={section.url}
              title='document'
              className={isDoc ? 'iframe-document' : 'document-viewer'}
            />
          )}
          {fileUpload?.enabled && (
            <TrainingUserFileUpload
              disabled={disabled}
              label={fileUpload?.label}
              description={fileUpload?.description}
              multiple={fileUpload?.multiple}
              fileType={fileUpload?.fileType}
              values={attachments}
              progress={attachmentProgress}
              onChange={onChangeAttachments}
            />
          )}
        </CardContent>

        {!disabled && (
          <CardActions className='lesson-actions'>
            {onPrevious && (
              <Button variant='contained' onClick={onPrevious}>
                Previous
              </Button>
            )}
            <span className='flex' />
            {onNext && (
              <Button
                variant='contained'
                color='primary'
                type='submit'
                onClick={onNext}
              >
                Next
              </Button>
            )}
          </CardActions>
        )}
      </div>
    </StyledPaper>
  );
};

export default TrainingLessonCard;
